'use strict';
module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);



//////////////////
// WEBPACK FOOTER
// ./~/strict-uri-encode/index.js
// module id = 645
// module chunks = 0